<ng-container *ngIf="!embedded">
<ng-container *ngIf="canRenderAppShell; else payrollThemeLoading">
<mat-menu #wellspacesMenu="matMenu">
    <div class="wellspacesMenu">
        <button *ngIf="teamAdminWellspaceCreationEnabled" mat-menu-item (click)="addWellspace()"><mat-icon>add</mat-icon>Add a Wellspace</button>
        <div *ngIf="wellspaces.length > 0">
            <mat-divider ></mat-divider>
            <span class="wellspacesection">Wellspaces</span><br>
            <input name="wellspacefilter" class="filterinput" matInput [(ngModel)]="wellspaceFilter" (click)="$event.stopPropagation()" (keyup)="applyFilter($event)" placeholder="Filter by...">
            <button *ngIf="wellspaceFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter($event)">
              <mat-icon>close</mat-icon>
            </button>
            <div *ngFor="let wellspace of filteredWellspaces" class="wellspaceitem" (click)="gotoWellspace(wellspace)">
                <button mat-menu-item>{{wellspace.name}}</button>
            </div>
        </div>
    </div>
</mat-menu>
<mat-toolbar
  [ngClass]="{'hidetoolbar': toolbarClass === 'hidetoolbar'}"
  *ngIf="ready && !this.router.url.includes('/2fa')">
   <button mat-icon-button class="example-icon" aria-label="Menu" (click)="toggleNav()">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="largemediaonly topleft">
      <span>{{leftTitle()}}</span>
      <span class="verticaldivider">|</span>
      <button mat-icon-button (click)="navigate('')"><mat-icon class="home">home</mat-icon></button>
  </div>
  <span *ngIf="!isCustomerSupport && !isPayrollAdminHostMode && !isNativeCompanyManager">{{currentWellspace.role ? 'Admin for': ''}} {{currentWellspace.name}} {{currentWellspace.companyName ? 'in ' + currentWellspace.companyName : ''}}</span>
  <span *ngIf="isNativeCompanyManager">{{nativeWorkspaceTeamName}}</span>
  <button *ngIf="isNativeTeamManager && wellspaces.length > 1" mat-button [matMenuTriggerFor]="wellspacesMenu" aria-label="Switch Team">
    <mat-icon>swap_horiz</mat-icon> Switch Team
  </button>
  <span *ngIf="isIntegrationAdmin">{{company?.company_type | titlecase }}{{company ? ':' : ''}} {{company?.name}}</span>
  <span *ngIf="isPayrollAdminHostMode">{{payrollCompanyName}}</span>
  <mat-spinner class="spinner" *ngIf="spinnerLevel > 0" [diameter]="36"></mat-spinner>
  <span class="spacer"></span>
  <div *ngIf="isIntegrationAdmin">
      <button class="topbutton" mat-icon-button (click)="actionsClicked()">
          <div class="buttonwrapper">
              <span [matBadge]="approvalCount" matBadgeColor="accent" [matBadgeHidden]="false"></span>
             <mat-icon svgIcon="bell"></mat-icon>
              <span class="iconlabel">Actions</span>
          </div>
      </button>
  </div>
  <div class="infowrapper">
      <ng-container *ngIf="useSharedAdminShell; else establishedToolbarInfo">
        <img *ngIf="brandUrl" [src]="brandUrl" class="brandlogo" (error)="onBrandLogoError()">
        <button
          class="shared-admin-user-menu-trigger"
          mat-icon-button
          [matMenuTriggerFor]="sharedAdminUserMenu"
          [attr.aria-label]="currentUserDisplayName ? 'Open account menu for ' + currentUserDisplayName : 'Open account menu'"
        >
          <span class="shared-admin-user-avatar">{{currentUserInitials}}</span>
        </button>
      </ng-container>
      <ng-template #establishedToolbarInfo>
        <ng-container *ngIf="isPayrollAdminHostMode; else legacyToolbarInfo">
          <img *ngIf="brandUrl" [src]="brandUrl" class="brandlogo" (error)="onBrandLogoError()">
          <button
            class="payroll-user-menu-trigger"
            mat-icon-button
            [matMenuTriggerFor]="payrollUserMenu"
            [attr.aria-label]="currentUserDisplayName ? 'Open account menu for ' + currentUserDisplayName : 'Open account menu'"
          >
            <span class="payroll-user-avatar">{{currentUserInitials}}</span>
          </button>
        </ng-container>
        <ng-template #legacyToolbarInfo>
          <div class="legacy-user-identity">
            <span class="userinfo">{{currentUserInfo}}</span>
            <div *ngIf="sensitiveDataAccessPills.length" class="sensitive-data-access-pills" aria-label="Sensitive data access">
              <span
                *ngFor="let pill of sensitiveDataAccessPills"
                class="sensitive-data-access-pill"
                [attr.title]="pill.capability"
              >{{pill.label}}</span>
            </div>
          </div>
          <img *ngIf="brandUrl" [src]="brandUrl" class="brandlogo" (error)="onBrandLogoError()">
        </ng-template>
      </ng-template>
  </div>
  <mat-menu #payrollUserMenu="matMenu">
      <button mat-menu-item (click)="navigate('profile')">
          <mat-icon>person</mat-icon>
          <span>Edit Profile</span>
      </button>
      <button mat-menu-item (click)="logoutClicked(false)">
          <mat-icon>logout</mat-icon>
          <span>Sign Out</span>
      </button>
  </mat-menu>
  <mat-menu #sharedAdminUserMenu="matMenu">
      <button mat-menu-item (click)="navigate('profile')">
          <mat-icon>person</mat-icon>
          <span>Account Profile</span>
      </button>
      <button mat-menu-item (click)="navigate('2fa/profile')">
          <mat-icon>security</mat-icon>
          <span>2FA</span>
      </button>
      <button mat-menu-item (click)="logoutClicked(false)">
          <mat-icon>logout</mat-icon>
          <span>Sign Out</span>
      </button>
  </mat-menu>
  <div *ngIf="isTeamAdminOrUnmatched && !isPayrollAdminHostMode && !useSharedAdminShell">
      <button class="topbutton" mat-icon-button (click)="plansClicked()">
        <div class="buttonwrapper">
            <mat-icon svgIcon="plans"></mat-icon>
            <span class="iconlabel">Plans</span>
        </div>
      </button>
      <button class="topbutton" mat-icon-button (click)="notificationsClicked()">
        <div class="buttonwrapper">
            <mat-icon>notifications</mat-icon>
            <span class="iconlabel">Notifications</span>
        </div>
      </button>
      <button class="topbutton" mat-icon-button [matMenuTriggerFor]="wellspacesMenu" >
        <div class="buttonwrapper">
            <mat-icon>grid_view</mat-icon>
            <span class="iconlabel">Wellspaces</span>
        </div>
      </button>
      <button class="topbutton" mat-icon-button (click)="helpClicked()">
        <div class="buttonwrapper">
            <mat-icon>help_outline</mat-icon>
            <span class="iconlabel">Help</span>
        </div>
      </button>
      <button class="topbutton" mat-icon-button (click)="launchClicked()">
        <div class="buttonwrapper">
            <img class="walliticon" src="assets/icons/favicon.png">
            <span class="iconlabel">Launch</span>
        </div>
      </button>
  </div>
  <span *ngIf="user && user.contact && !useSharedAdminShell">{{user.contact.name || user.contact.email}}</span>
</mat-toolbar>
<mat-sidenav-container hasBackdrop="false" autosize="true">
  <mat-sidenav
    *ngIf="isLoggedIn && !this.router.url.includes('/2fa')"
    [class.sidenav]="!isPayrollAdminHostMode"
    [class.branded-sidenav]="isPayrollAdminHostMode"
    #sidenav
    [mode]="sidenavMode"
    [opened]="sidenavOpened"
    (openedChange)="sidenavOpened = $event">
    <div class="sidenavwrapper">
        <div class="topside">
            <mat-accordion multi>
                <ng-container *ngIf="canRenderNativeNavigation">
                  <div>
                    <mat-expansion-panel expanded="true">
                      <mat-expansion-panel-header>
                        <span class="section">NAVIGATION</span>
                      </mat-expansion-panel-header>
                      <button class="leftbutton" [class.leftbutton-active]="isRouteActive('')" mat-icon-button (click)="navigate('')">
                        <mat-icon>home</mat-icon>
                        Home
                      </button>
                      <button *ngIf="companyOffersAccess.allowedContext$ | async" class="leftbutton" [class.leftbutton-active]="isRouteActive('offers')" mat-icon-button (click)="navigate('offers')">
                        <mat-icon>local_offer</mat-icon>
                        Offers
                      </button>
                      <button class="leftbutton" mat-icon-button (click)="wallitClicked()">
                        <mat-icon>keyboard_return</mat-icon>
                        Back to Wallit
                      </button>
                    </mat-expansion-panel>
                  </div>
                  <div>
                    <mat-expansion-panel expanded="true">
                      <mat-expansion-panel-header>
                        <span class="section">MANAGEMENT</span>
                      </mat-expansion-panel-header>
                      <button class="leftbutton" [class.leftbutton-active]="isNativeTeamManager ? (isRouteActive('my-team') || isRouteActive('managewellspace')) : isRouteActive('payrolladmin/teams')" mat-icon-button (click)="navigate(isNativeTeamManager ? 'my-team' : 'payrolladmin/teams')">
                        <mat-icon>groups</mat-icon>
                        {{ isNativeTeamManager ? 'My Team' : 'Teams' }}
                      </button>
                      <button *ngIf="canAccessPayrollExpenseApprovals || isNativeTeamManager" class="leftbutton" [disabled]="isNativeTeamManager && !currentWellspace.name" [class.leftbutton-active]="isRouteActive(isNativeTeamManager ? 'purchases' : 'payrolladmin/expense-approvals')" mat-icon-button (click)="navigate(isNativeTeamManager ? 'purchases' : 'payrolladmin/expense-approvals')">
                        <mat-icon>fact_check</mat-icon>
                        <span [matBadge]="approvalCount" matBadgeColor="accent" [matBadgeHidden]="!isNativeTeamManager || approvalCount === 0">Approvals</span>
                      </button>
                      <button class="leftbutton" [class.leftbutton-active]="isRouteActive('dashboards')" mat-icon-button (click)="navigate('dashboards')">
                        <mat-icon>dashboard</mat-icon>
                        Dashboards
                      </button>
                      <button class="leftbutton" [class.leftbutton-active]="isRouteActive('analytics')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('analytics')">
                        <mat-icon>insights</mat-icon>
                        Analytics
                      </button>
                      <button *ngIf="nativeCompanyHasBenefits && !isNativeTeamManager" class="leftbutton" [class.leftbutton-active]="isRouteActive('payrolladmin/benefits')" mat-icon-button (click)="navigate('payrolladmin/benefits')">
                        <mat-icon>favorite_border</mat-icon>
                        Benefits
                      </button>
                      <button *ngIf="canShowNativeBilling" class="leftbutton" [class.leftbutton-active]="isRouteActive('billing')" mat-icon-button (click)="navigate('billing/stripechargehistory')">
                        <mat-icon>credit_card</mat-icon>
                        <span [matBadge]="badgeCount" matBadgeColor="accent" [matBadgeHidden]="badgeCount === 0">Billing</span>
                      </button>
                    </mat-expansion-panel>
                  </div>
                  <div>
                    <mat-expansion-panel expanded="true">
                      <mat-expansion-panel-header>
                        <span class="section">RESOURCES</span>
                      </mat-expansion-panel-header>
                      <button class="leftbutton" mat-icon-button (click)="plansClicked()">
                        <mat-icon svgIcon="plans"></mat-icon>
                        Plans & Features
                      </button>
                      <button class="leftbutton" mat-icon-button (click)="helpClicked()">
                        <mat-icon>help_outline</mat-icon>
                        Help Center
                      </button>
                    </mat-expansion-panel>
                  </div>
                </ng-container>
                <ng-container *ngIf="canRenderEstablishedNavigation">
                <div *ngIf="!isPayrollAdminHostMode && useSharedAdminShell">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">NAVIGATION</span>
                        </mat-expansion-panel-header>
                      <button *ngIf="isTeamAdminOrUnmatched" class="leftbutton" mat-icon-button (click)="wallitClicked()">
                            <mat-icon>keyboard_return</mat-icon>
                            Back to Wallit
                      </button>
                      <button class="leftbutton" [class.leftbutton-active]="isRouteActive('')" mat-icon-button (click)="navigate('')">
                            <mat-icon>home</mat-icon>
                            Home
                      </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="!isPayrollAdminHostMode && !useSharedAdminShell">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">ACCOUNT</span>
                        </mat-expansion-panel-header>
                      <button *ngIf="isTeamAdminOrUnmatched" class="leftbutton" mat-icon-button (click)="wallitClicked()">
                            <mat-icon>keyboard_return</mat-icon>
                            Back to Wallit
                      </button>
                      <button class="leftbutton" [class.leftbutton-active]="isRouteActive('')" mat-icon-button (click)="navigate('')">
                            <mat-icon>home</mat-icon>
                            Home
                      </button>
                      <button *ngIf="!isCustomerSupport" class="leftbutton" [class.leftbutton-active]="isRouteActive('profile')" mat-icon-button (click)="navigate('profile')">
                            <mat-icon>person</mat-icon>
                            Account Profile
                      </button>
                        <button *ngIf="!isCustomerSupport" class="leftbutton" [class.leftbutton-active]="isRouteActive('2fa/profile')" mat-icon-button (click)="navigate('2fa/profile')">
                            <mat-icon>security</mat-icon>
                            2FA
                        </button>
                        <!--
                        <button *ngIf="!isCustomerSupport && !isBrokerAdmin" class="leftbutton" mat-icon-button (click)="navigate('insuranceprofile')">
                            <mat-icon>medical_services</mat-icon>
                            Insurance Profile
                        </button>
                        -->
                      <button class="leftbutton" mat-icon-button (click)="logoutClicked(false)">
                            <mat-icon>logout</mat-icon>
                            Sign Out
                      </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="!isPayrollAdminHostMode && useSharedAdminShell">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">RESOURCES</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="plansClicked()">
                            <mat-icon svgIcon="plans"></mat-icon>
                            Plans & Features
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="helpClicked()">
                            <mat-icon>help_outline</mat-icon>
                            Help Center
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="roles?.client && !roles?.manager && !roles?.broker && !roles?.agency && !roles?.member && !roles?.supportAdmin && !roles?.supportAgent && !roles?.teamAgent && !isSuperAdmin">
                    <mat-expansion-panel expanded="true">
                        <mat-expansion-panel-header>
                            <span class="section">BENEFITS ADMINISTRATION</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('brokeragency/clients/client-census')">
                            <mat-icon>business</mat-icon>
                            Census & Eligibility
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="isBrokerAdmin || isSuperAdmin">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">BROKER & AGENCY</span>
                        </mat-expansion-panel-header>
                        <button *ngIf="roles?.broker || isSuperAdmin" class="leftbutton" mat-icon-button (click)="navigate('brokeragency/broker/broker-agencies')">
                            <mat-icon>store</mat-icon>
                            Broker
                        </button>
                        <button *ngIf="roles?.broker || roles?.agency || isSuperAdmin" class="leftbutton" mat-icon-button (click)="navigate('brokeragency/agency/agency-clients')">
                            <mat-icon>badge</mat-icon>
                            Agency
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('brokeragency/clients/client-census')">
                            <mat-icon>business</mat-icon>
                            Clients
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="isSuperAdmin || isFinanceAdmin">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">FINANCE</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/ledger')">
                            <mat-icon>account_balance</mat-icon>
                            Accounting
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/contracts')">
                            <mat-icon>description</mat-icon>
                            Contracts
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/reports')">
                            <mat-icon>assessment</mat-icon>
                            Reports
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/bank-reconciliation')">
                            <mat-icon>account_balance_wallet</mat-icon>
                            Bank Reconciliation
                        </button>
                        <button *ngIf="isExactSuperAdmin" class="leftbutton" mat-icon-button (click)="navigate('finance/connections')">
                            <mat-icon>link</mat-icon>
                            Connections
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="isCustomerSupport || isSuperAdmin">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">SUPPORT</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('customersupport/managecustomers')">
                            <mat-icon>person_search</mat-icon>
                            Manage Customers
                        </button>
                        <button *ngIf="roles?.supportAdmin || isSuperAdmin" class="leftbutton" mat-icon-button (click)="navigate('customersupport/managesupportagents')">
                            <mat-icon>supervisor_account</mat-icon>
                            Manage Agents
                        </button>
                        <button *ngIf="roles?.supportAdmin || isSuperAdmin" class="leftbutton" mat-icon-button (click)="navigate('customersupport/reports')">
                            <mat-icon>assessment</mat-icon>
                            Reports
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="!isPayrollAdminHostMode">
                  <mat-expansion-panel expanded="true">
                    <mat-expansion-panel-header>
                      <span class="section">ADMINISTRATION</span>
                    </mat-expansion-panel-header>
                    <button class="leftbutton" [class.leftbutton-active]="isRouteActive('dashboards')" mat-icon-button (click)="navigate('dashboards')">
                        <mat-icon>dashboard</mat-icon>
                        Dashboards
                    </button>
                    <button *ngIf="isTeamAdminOrUnmatched" class="leftbutton" [class.leftbutton-active]="isRouteActive('analytics')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('analytics')">
                        <mat-icon>insights</mat-icon>
                        Analytics
                    </button>
                    <button *ngIf="isTeamAdminOrUnmatched" class="leftbutton" [class.leftbutton-active]="isRouteActive('managewellspace')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('managewellspace/overview/current')">
                        <mat-icon>groups</mat-icon>
                        Manage Your Wellspace
                    </button>
                    <button *ngIf="isTeamAdminOrUnmatched && !isTeamAgentSession && !isTeamAgentOnly" class="leftbutton" [class.leftbutton-active]="isRouteActive('purchases')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('purchases')">
                         <mat-icon>receipt</mat-icon>
                         <span [matBadge]="approvalCount" matBadgeColor="accent" [matBadgeHidden]="approvalCount === 0">
                            Approvals
                         </span>
                    </button>
                    <button *ngIf="isTeamAdminOrUnmatched && !isTeamAgentSession && !isTeamAgentOnly" class="leftbutton" [class.leftbutton-active]="isRouteActive('billing')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('billing/stripechargehistory')">
                        <mat-icon>credit_card</mat-icon>
                        <span [matBadge]="badgeCount" matBadgeColor="accent" [matBadgeHidden]="badgeCount === 0">Billing</span>
                    </button>
                  </mat-expansion-panel>
                </div>
                <div *ngIf="isIntegrationAdmin">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">INSURANCE</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/carriers')">
                            <mat-icon>business</mat-icon>
                            Carriers
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/brokers')">
                            <mat-icon>store</mat-icon>
                            Brokers
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/employers')">
                            <mat-icon>badge</mat-icon>
                            Employers
                        </button>
                        <mat-divider></mat-divider>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/products')">
                            <mat-icon>receipt_long</mat-icon>
                            Companies
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/policies')">
                            <mat-icon>policy</mat-icon>
                            Policies
                        </button>
                        <mat-divider></mat-divider>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/users')">
                            <mat-icon>people</mat-icon>
                            Users
                        </button>
                    </mat-expansion-panel>
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">ADVERTISING</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/advertisers')">
                            <mat-icon>corporate_fare</mat-icon>
                            Advertisers
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/campaigns')">
                            <mat-icon>date_range</mat-icon>
                            Campaigns
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/ads')">
                            <mat-icon>ad_units</mat-icon>
                            Ads
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/creatives')">
                            <mat-icon>palette</mat-icon>
                            Creatives
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/flights')">
                            <mat-icon>flights</mat-icon>
                            Flights
                        </button>
                        <mat-divider></mat-divider>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/impressions')">
                            <mat-icon>visibility</mat-icon>
                            Impressions
                        </button>
                    </mat-expansion-panel>
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">MEDIA</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('media/images')">
                            <mat-icon>photo_llibrary</mat-icon>
                            Images
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('media/documents')">
                            <mat-icon>description</mat-icon>
                            Documents
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('media/content')">
                            <mat-icon>web</mat-icon>
                            Content
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="isPayrollAdminHostMode">
                    <mat-expansion-panel [expanded]="payrollSectionExpanded" (opened)="payrollSectionExpanded = true" (closed)="payrollSectionExpanded = false">
                      <mat-expansion-panel-header>
                        <span class="section">PAYROLL</span>
                      </mat-expansion-panel-header>
                      <button class="leftbutton" mat-icon-button (click)="navigate('')">
                            <mat-icon>home</mat-icon>
                            Home
                      </button>
                      <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/dashboards')">
                        <mat-icon>dashboard</mat-icon>
                        Dashboards
                      </button>
                      <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/company/company')">
                        <mat-icon>business</mat-icon>
                        Company
                      </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/teams')">
                          <mat-icon>person_search</mat-icon>
                          Teams
                        </button>
                        <button *ngIf="canAccessPayrollExpenseApprovals" class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/expense-approvals')">
                          <mat-icon>fact_check</mat-icon>
                          Expense Approvals
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/benefits')">
                            <mat-icon>favorite_border</mat-icon>
                            Benefits
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/deductions')">
                            <mat-icon>payments</mat-icon>
                            Payroll Deductions
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="!isPayrollAdminHostMode && (roles?.manager || roles?.teamAgent || canShowPayrollAdminNavigation) && (!isCustomerSupport || isSuperAdmin)">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">MANAGERS</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('products')" mat-icon-button (click)="navigate('products')">
                            <mat-icon>receipt_long</mat-icon>
                            Companies
                        </button>
                        <button *ngIf="canShowPayrollAdminNavigation" class="leftbutton" mat-icon-button (click)="navigateToPayrollAdmin()">
                            <mat-icon>payments</mat-icon>
                            Payroll
                        </button>
                    </mat-expansion-panel>
                </div>
                <div class="content-nav-section" *ngIf="isContentAdmin || isSuperAdmin">
                  <mat-expansion-panel expanded="false">
                    <mat-expansion-panel-header>
                      <span class="section">CONTENT</span>
                    </mat-expansion-panel-header>
                    <button class="leftbutton" mat-icon-button (click)="navigate('contentadmin/vendors')">
                      <mat-icon>domain</mat-icon>
                      Vendors
                    </button>
                    <button class="leftbutton" mat-icon-button (click)="navigate('contentadmin/adminFees')">
                      <mat-icon>price_change</mat-icon>
                      Admin Fees
                    </button>
                    <button *ngIf="isSuperAdmin" class="leftbutton" mat-icon-button (click)="navigate('superadmin/rewards')">
                      <mat-icon>redeem</mat-icon>
                      Rewards/Snacks
                    </button>
                    <button *ngIf="isSuperAdmin" class="leftbutton" mat-icon-button (click)="navigate('vendor-products/stripe-products')">
                      <mat-icon>inventory</mat-icon>
                      Products
                    </button>
                  </mat-expansion-panel>
                </div>
                <div *ngIf="isSuperAdmin">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">DATA</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/inbound-file-feeds')">
                            <mat-icon>move_to_inbox</mat-icon>
                            Inbound Feeds
                        </button>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('superadmin/product-click-events')" mat-icon-button (click)="navigate('superadmin/product-click-events')">
                            <mat-icon>ads_click</mat-icon>
                            Product Click Events
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('marketing-campaigns')">
                            <mat-icon>campaign</mat-icon>
                            Marketing
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/dashboards')">
                            <mat-icon>dashboard</mat-icon>
                            Dashboards
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/reports')">
                            <mat-icon>insights</mat-icon>
                            Scheduled Reports
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="isSuperAdmin">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">SUPER ADMIN</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('teampayments')" mat-icon-button (click)="navigate('teampayments')">
                              <mat-icon>grid_view</mat-icon>
                              All Wellspaces
                        </button>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('products')" mat-icon-button (click)="navigate('products')">
                              <mat-icon>receipt_long</mat-icon>
                              Companies
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('vendorgroups')">
                            <mat-icon>supervisor_account</mat-icon>
                            Insurance Groups
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/payrollvendors')">
                            <mat-icon>domain</mat-icon>
                            Payroll Providers
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/users')">
                            <mat-icon>people</mat-icon>
                            Users
                        </button>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('superadmin/sensitive-data-access')" mat-icon-button (click)="navigate('superadmin/sensitive-data-access')">
                            <mat-icon>policy</mat-icon>
                            Sensitive Data Access
                        </button>
                        <!--
                        <button class="leftbutton" mat-icon-button (click)="navigate('provisioning')">
                            <mat-icon>shopping_basket</mat-icon>
                            Provisioning
                        </button>
                        -->
                        <button *ngIf="checkClientFeaturePermission()" class="leftbutton" mat-icon-button (click)="navigate('clients')">
                            <mat-icon>person</mat-icon>
                            Clients
                        </button>
                        <!--
                        <button class="leftbutton" mat-icon-button (click)="navigate('externalbrokeradmin')">
                            <mat-icon>ballot</mat-icon>
                            Broker Admin
                        </button>
                        -->
                    </mat-expansion-panel>
                </div>
                <div *ngIf="isSuperAdmin && isFinanceAdmin">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">FINANCE</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/ledger')">
                            <mat-icon>account_balance</mat-icon>
                            Accounting
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/contracts')">
                            <mat-icon>description</mat-icon>
                            Contracts
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/reports')">
                            <mat-icon>assessment</mat-icon>
                            Reports
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/bank-reconciliation')">
                            <mat-icon>account_balance_wallet</mat-icon>
                            Bank Reconciliation
                        </button>
                        <button *ngIf="isExactSuperAdmin" class="leftbutton" mat-icon-button (click)="navigate('finance/connections')">
                            <mat-icon>link</mat-icon>
                            Connections
                        </button>
                    </mat-expansion-panel>
                </div>
                <div *ngIf="isSuperAdmin">
                    <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                            <span class="section">SYSTEM</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/ai-assistant')">
                            <mat-icon>smart_toy</mat-icon>
                            AI Assistant
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('contentadmin/brands')">
                            <mat-icon>domain</mat-icon>
                            Brands
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/brand-domains')">
                            <mat-icon>cloud</mat-icon>
                            Brand Domains
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/json-config')">
                            <mat-icon>settings</mat-icon>
                            JSON Global Config
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/managed-feature-flags')">
                            <mat-icon>toggle_on</mat-icon>
                            Managed Feature Flags
                        </button>
                        <button *ngIf="isExactSuperAdmin" class="leftbutton" [class.leftbutton-active]="isRouteActive('superadmin/observability')" mat-icon-button (click)="navigate('superadmin/observability')">
                            <mat-icon>monitor_heart</mat-icon>
                            Observability
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('workflows')">
                            <mat-icon>account_tree</mat-icon>
                            Workflows
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('env-sync')">
                            <mat-icon>sync</mat-icon>
                            Environment Sync
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('convert-834')">
                            <mat-icon>swap_horiz</mat-icon>
                            Convert 834
                        </button>
                    </mat-expansion-panel>
                </div>
                </ng-container>
                <span class="version">Version {{info}}</span>
            </mat-accordion>
        </div>
        <!--<span class="sidebottom">Made with &hearts; by Wallit</span>-->
    </div>
  </mat-sidenav>
  <mat-sidenav-content [class.shared-admin-sidenav-content]="useSharedAdminShell">
    <div [ngClass]="{'content': !this.router.url.includes('/2fa')}">
        <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
</ng-container>
<ng-template #payrollThemeLoading>
  <div class="payroll-theme-loading">
    <mat-spinner [diameter]="42"></mat-spinner>
  </div>
</ng-template>
</ng-container>
<router-outlet *ngIf="embedded"></router-outlet>
<div class="loading-indicator" *ngIf="showLoading">
    <mat-spinner [diameter]="50"></mat-spinner>
    <span class="loadingmessage">{{spinnerMessage ? spinnerMessage : 'Wait'}}...</span>
</div>
